import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

const industriesQueryKey = (query?: string) => ["advanced-industries", query];

type Props = {
  query?: string;
};

export const useGetAllNaceIndustries = ({ query }: Props) => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: industriesQueryKey(query),
    queryFn: () =>
      apiClient.industries.searchNaceIndustries({
        query: query ? query : undefined,
      }),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
